import { createRouter } from '@tanstack/react-router';
import type { QueryClient } from '@tanstack/react-query';
import { routeTree } from './routeTree.gen';
import { CenteredSpinner } from './components/CenteredSpinner';
import type { AuthContextValue } from './hooks/useAuth';

export interface RouterContext {
  auth: AuthContextValue;
  queryClient: QueryClient;
}

export const router = createRouter({
  routeTree,
  context: undefined!,
  // Prefetch route chunks + loader data on link hover/touchstart.
  defaultPreload: 'intent',
  // TanStack Query owns data freshness: always re-run loaders on preload and
  // let `queryClient.ensureQueryData` decide whether to hit the network.
  defaultPreloadStaleTime: 0,
  // Shown while a route loader is still in flight (after `pendingMs`).
  defaultPendingComponent: CenteredSpinner,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
